/**
 * 追加style到head
 */
var msgEleStyle=document.createElement("style");
msgEleStyle.setAttribute("from","IDM-Message-Style-Code");
msgEleStyle.innerHTML=`.IDM-Message.IDM-Message-wrapper{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.55);font-size:13px;font-variant:tabular-nums;line-height:1;list-style:none;font-feature-settings:"tnum";position:fixed;top:16px;left:0;z-index:1010;width:100%;pointer-events:none;}.IDM-Message .IDM-Message-item{padding:8px;text-align:center;-webkit-animation-duration:.3s;animation-duration:.3s;position:relative;}.IDM-Message .IDM-Message-item .IDM-Message-count{text-align:center;position:absolute;left:-4px;top:-4px;background-color:red;color:#fff;font-size:12px;line-height:16px;border-radius:2px;display:inline-block;min-width:16px;height:16px;-webkit-animation-duration:.3s;animation-duration:.3s;border-radius:4px;}.IDM-Message .IDM-Message-item:first-child{margin-top:-8px;}.IDM-Message .IDM-Message-content{text-align:left;position:relative;display:inline-block;padding:10px 16px;background:#fff;border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,.15);pointer-events:all;max-width:80%;min-width:80px;}.IDM-Message .IDM-Message-content [class^="IDM-Message-content-"]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-height:21px;line-height:21px;}.IDM-Message .IDM-Message-content .IDM-Message-content-with-close{padding-right:20px;}.IDM-Message .IDM-Message-icon{display:inline-block;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:relative;top:1px;margin-right:8px;font-size:16px;}.IDM-Message .IDM-Message-icon svg{display:inline-block;}.IDM-Message .IDM-Message-content-info .IDM-Message-icon{color:#1890ff;user-select:none;}.IDM-Message .IDM-Message-content-success .IDM-Message-icon{color:#52c41a;}.IDM-Message .IDM-Message-content-error .IDM-Message-icon{color:#f5222d;}.IDM-Message .IDM-Message-content-warning .IDM-Message-icon{color:#faad14;}.IDM-Message .IDM-Message-icon-close{position:absolute;top:12px;right:5px;padding:0;overflow:hidden;font-size:12px;line-height:22px;background-color:transparent;border:none;outline:none;cursor:pointer;color:rgba(0,0,0,.45);transition:color .3s}.IDM-Message .IDM-Message-icon-close:hover>svg path{stroke:#555;}.IDM-Message .animate-turn{animation:IDMMessageTurn 1s linear infinite;-webkit-animation:IDMMessageTurn 1s linear infinite;}@keyframes IDMMessageTurn{0%{-webkit-transform:rotate(0deg);}25%{-webkit-transform:rotate(90deg);}50%{-webkit-transform:rotate(180deg);}75%{-webkit-transform:rotate(270deg);}100%{-webkit-transform:rotate(360deg);}}@-webkit-keyframes IDMMessageTurn{0%{-webkit-transform:rotate(0deg);}25%{-webkit-transform:rotate(90deg);}50%{-webkit-transform:rotate(180deg);}75%{-webkit-transform:rotate(270deg);}100%{-webkit-transform:rotate(360deg);}}@-webkit-keyframes IDMMessageMoveOut{0%{max-height:150px;padding:8px;opacity:1}to{max-height:0;padding:0;opacity:0}}@keyframes IDMMessageMoveOut{0%{max-height:150px;padding:8px;opacity:1}to{max-height:0;padding:0;opacity:0}}@-webkit-keyframes IDMMessageMoveIn{0%{transform:translateY(-100%);transform-origin:0 0;opacity:0}to{transform:translateY(0);transform-origin:0 0;opacity:1}}@keyframes IDMMessageMoveIn{0%{transform:translateY(-100%);transform-origin:0 0;opacity:0}to{transform:translateY(0);transform-origin:0 0;opacity:1}}@-webkit-keyframes IDMMessageShake{0%,100%{transform:translateX(0px);opacity:1;}25%,75%{transform:translateX(-4px);opacity:0.75;}50%{transform:translateX(4px);opacity:0.25;}}@keyframes IDMMessageShake{0%,100%{transform:translateX(0px);opacity:1;}25%,75%{transform:translateX(-4px);opacity:0.75;}50%{transform:translateX(4px);opacity:0.25;}}`;
document.getElementsByTagName('head')[0].appendChild(msgEleStyle)

/**
 * 声明插件名称
 */
var PLUGIN_NAME = "IDM-Message";

/**
 * 命名空间 用于css和事件
 */
var NAMESPACE = PLUGIN_NAME;

/**
 * 状态 & 动画
 * 显示中，显示完成，关闭中
 */
var STATES = {
    opening : 'IDMMessageMoveIn',
    done : '',
    closing : 'IDMMessageMoveOut'
}

/**
 * 全局默认配置
 * position {String} 位置，仅支持'center','right','left',默认'center'
 * type {String} 类型，支持'info','warning','success','error','loading'
 * showClose {Boolean} 是否显示关闭图标，默认为false不显示
 * timeout {Number} 多久后自动关闭，单位ms,默认2500
 * autoClose {Boolean} 是否自动关闭，默认true,注意在type为loading的时候自动关闭为false
 * content {String} 提示的内容
 * onClose {Function} 关闭的回调函数
 */
var DEFAULTS = Object.assign({
    position:'center',
    type:"info", 
    showClose:false,
    timeout:2500,
    animation:true,
    autoClose:true,
    content:"",
    onClose:null,
    maxNums:5,
    html:false
},window.IDM && window.IDM.message && window.IDM.message.DEFAULTS)

    /**
 * 设置icon html代码
 */
var ICONS = {
    info:'<svg viewBox="64 64 896 896" focusable="false" data-icon="info-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"></path></svg>',
    warning:'<svg viewBox="64 64 896 896" focusable="false" data-icon="exclamation-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"></path></svg>',
    error:'<svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>',
    success:'<svg viewBox="64 64 896 896" data-icon="check-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path></svg>',
    loading:'<svg class="animate-turn" width="16" height="16" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" fill="white" fill-opacity="0.01"/><path d="M4 24C4 35.0457 12.9543 44 24 44V44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4" stroke="#1890ff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M36 24C36 17.3726 30.6274 12 24 12C17.3726 12 12 17.3726 12 24C12 30.6274 17.3726 36 24 36V36" stroke="#1890ff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    close:'<svg width="16" height="16" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" fill="white" fill-opacity="0.01"/><path d="M14 14L34 34" stroke="#909399" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 34L34 14" stroke="#909399" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
}

    /**
 * 是否支持动画属性
 * @type {Boolean}
 */
var CAN_ANIMATION = (function() {
    var style = document.createElement('div').style;
    return style.animationName !== undefined ||
        style.WebkitAnimationName !== undefined ||
        style.MozAnimationName !== undefined ||
        style.msAnimationName !== undefined ||
        style.OAnimationName !== undefined;
})();

/**
 * 生成带插件名的名称
 * @param {...String}
 * @returns {String}
 */
function namespacify(){
    var res = NAMESPACE;
    for(var i = 0; i < arguments.length; ++i){
        res += '-' + arguments[i];
    }
    return res;
}

/**
 * 每条消息的构造函数
 * @param {Objetc} opts 配置参数，参考DEFAULTS
 */
function Msg(opts){
    var oMsg = this;
    oMsg.settings = Object.assign({},DEFAULTS,opts||{});
    oMsg.id = IDM.message.instanceCount;
    var timeout = oMsg.settings.timeout;
    timeout = timeout && parseInt(timeout>=0) & parseInt(timeout)<=Math.NEGATIVE_INFINITY ?parseInt(timeout):DEFAULTS.timeout;
    oMsg.timeout = timeout;
    oMsg.settings.timeout = timeout;
    oMsg.timer = null;
    var $elem = document.createElement("div");
    var $svg = ICONS[oMsg.settings.type || 'info'];
    var contentClassName = namespacify("content-"+oMsg.settings.type || 'info');
    contentClassName +=oMsg.settings.showClose ?' '+ namespacify('content-with-close'):''
    var content = oMsg.settings.content || '';
    var $closeSvg = ICONS['close'];
    var $closeIcon = oMsg.settings.showClose ? '<i class="'+NAMESPACE+'-icon '+NAMESPACE+'-icon-close">'+$closeSvg+'</i>':'';
    var $span = document.createElement("span");
    if(oMsg.settings.html){
        $span.innerHTML = content;
    }else{
        $span.innerText = content;
    }
    $elem.innerHTML = '<div class="'+NAMESPACE+'-content">\
        <div class="'+contentClassName+'">\
            <i class="'+NAMESPACE+'-icon">'+$svg+'</i>'+$span.outerHTML + $closeIcon +
            '</div>\
    </div>';

    $elem.classList.add(namespacify('item'));
    $elem.style.textAlign = oMsg.settings.position;
    var $wrapper = document.querySelector('.'+NAMESPACE);
    if(!$wrapper){
        $wrapper =  document.createElement("div");
        $wrapper.classList.add(NAMESPACE,namespacify('wrapper'),namespacify('is-initialized'));
        document.body.appendChild($wrapper);
    }
    $wrapper.appendChild($elem);
    oMsg.$wrapper = $wrapper;
    oMsg.$elem = $elem;
    setState(oMsg,'opening');
    if(oMsg.settings.showClose){ //关闭按钮绑定点击事件
        $elem.querySelector("."+NAMESPACE+"-icon-close").addEventListener('click',function(){
            oMsg.close();
        }.bind($elem))
    }
    $elem.addEventListener("animationend", function(e) {   // 监听动画完成
        var target = e.target,animationName = e.animationName;
        if(animationName == STATES['closing']){
            clearInterval(this.timer);
            this.destroy();
        }
        target.style.animationName = '';
        target.style.webkitAnimationName = '';
    }.bind(oMsg))
    if(oMsg.settings.autoClose){ // 自动关闭
        var intvMs = 10; // 定时器频率
        oMsg.timer = setInterval(function(){
            this.timeout -= intvMs;
            if(this.timeout <= 0){
                clearInterval(this.timer)
                this.close();
            }
        }.bind(oMsg),intvMs);
        oMsg.$elem.addEventListener('mouseover',function(){
            clearInterval(this.timer)
        }.bind(oMsg))
        oMsg.$elem.addEventListener('mouseout',function(){
            if(this.state!='closing'){ // 状态为关闭则不重启定时器
                this.timer = setInterval(function(){
                    this.timeout -= intvMs;
                    if(this.timeout <= 0){
                        clearInterval(this.timer);
                        this.close();
                    }
                }.bind(oMsg),intvMs);
            }
        }.bind(oMsg))
    }
}

function setState(inst,state){
    if(!state || !STATES[state]) return;
    inst.state = state;
    inst.$elem.style.animationName = STATES[state];
}

/**
 * 直接销毁元素，不会触发关闭回调函数
 */
Msg.prototype.destroy = function(){
    this.$elem.parentNode && this.$elem.parentNode.removeChild(this.$elem);
    clearInterval(this.timer);
    IDM.message.remove(this.id);
}
/**
 * 关闭，支持动画则会触发动画事件
 */
Msg.prototype.close = function(){
    setState(this,'closing');
    if(!CAN_ANIMATION){ // 不支持动画
        this.destroy();
    }else{
        IDM.message.remove(this.id);
    }
    var callback = this.settings.onClose;
    if(callback && callback instanceof Function){
        callback.call(this);
    }
}

/**
 * 设置消息数量统计
 * @private
 */
function setMsgCount(oMsg){
    var countClassName = namespacify('count');
    var $content = oMsg.$elem.querySelector("."+namespacify('content')),
    $count = $content.querySelector('.'+countClassName);
    if(!$count){
        $count = document.createElement("span");
        $count.classList.add(countClassName);
        $content.appendChild($count);
    }
    $count.innerHTML = oMsg.count;
    $count.style.animationName = "";
    $count.style.animationName = "IDMMessageShake";
    oMsg.timeout = oMsg.settings.timeout || DEFAULTS.timeout;
}

/**
 * 合并参数为配置信息，用于创建Msg实例
 * @param {String} txt 文本内容
 * @param {Object} config 配置
 * @private
 */
function mergeArgs(txt,config){
    var opts = Object.assign({},DEFAULTS);
    if(arguments.length===0){
        return opts;
    }
    if(txt instanceof Object){
        return Object.assign(opts,txt);
    }else{
        opts.content = txt.toString();
    }
    if(config instanceof Object){
        return Object.assign(opts,config)
    }
    return opts;
}

/**
 * 通过配置信息 来判断是否为同一条消息,并返回消息实例
 * @param {Object} params 配置项
 * @private
 */
function judgeReMsg(params){
    params = params || {};
    var opt = JSON.stringify(params)
    var oInx = -1;
    var oMsg ;
    for(var i in this.oMsgs){
        var oMsgItem = this.oMsgs[i];
        if(oMsgItem.config == opt) {
            oInx = i;
            oMsg = oMsgItem.inst;
            break;
        }
    }
    if(oInx < 0){
        this.instanceCount ++;
        var oItem = {};
        oItem.id = this.instanceCount;
        oItem.config = opt;
        oMsg = new Msg(params);
        oMsg.id = this.instanceCount;
        oMsg.count = '';
        oItem.inst = oMsg;
        this.oMsgs[this.instanceCount] = oItem;
        var len = this.oMsgs.length;
        var maxNums = this.maxNums;
        /**
         * 关闭多余的消息
        */
        if(len > maxNums){
            var oIndex = 0;
            var oMsgs = this.oMsgs;
            for(oIndex;oIndex<len-maxNums;oIndex++){
                oMsgs[oIndex] && oMsgs[oIndex].inst.settings.autoClose && oMsgs[oIndex].inst.close();
            }
        }
    }else{
        oMsg.count = !oMsg.count ? 2 : oMsg.count>=99 ? oMsg.count : oMsg.count+1;
        setMsgCount(oMsg);
    }
    oMsg.$elem.setAttribute("data-count",oMsg.count);
    return oMsg;
}
var message = {
    version:'0.0.1',
    instanceCount:0,
    oMsgs:[],
    maxNums:DEFAULTS.maxNums || 5,
    config:function(cfg){
        DEFAULTS = cfg && cfg instanceof Object ? Object.assign(DEFAULTS,cfg):DEFAULTS;
        this.maxNums = DEFAULTS.maxNums && DEFAULTS.maxNums > 0 ? parseInt(DEFAULTS.maxNums) : 3;
    },
    info:function(txt,config){
        var params = mergeArgs(txt,config);
        params.type = 'info';
       return judgeReMsg.call(this,params);
    },
    warning:function(txt,config){
        var params = mergeArgs(txt,config);
        params.type = 'warning';
       return judgeReMsg.call(this,params);
    },
    success:function(txt,config){
        var params = mergeArgs(txt,config);
        params.type = 'success';
       return judgeReMsg.call(this,params);
    },
    error:function(txt,config){
        var params = mergeArgs(txt,config);
        params.type = 'error';
       return judgeReMsg.call(this,params);
    },
    loading:function(txt,config){
        var params = mergeArgs(txt,config);
        params.type = 'loading';
        params.autoClose = false;
       return judgeReMsg.call(this,params);
    },
    remove:function(id){
        this.oMsgs[id] && delete this.oMsgs[id];
    },
    closeAll:function(){
        for(var i in this.oMsgs){
            this.oMsgs[i] && this.oMsgs[i].inst.close();
        }
    }
}
export default message;